// extracted by mini-css-extract-plugin
export default {"LogoutBodyWrapper":"styles_LogoutBodyWrapper__MYb26"};